import { http } from "./http.js";

export interface EventSummary {
  idempotency_key: string;
  platform: string;
  shop_id: string;
  platform_order_id: string;
  raw_event_type: string;
  process_status: string;
  attempts: number;
  error_code: string | null;
  error_message: string | null;
  received_at: number;
  processed_at: number | null;
}

export async function recentEvents(opts: { status?: string; limit?: number } = {}): Promise<EventSummary[]> {
  const params: Record<string, string> = {};
  if (opts.status) params["status"] = opts.status;
  if (opts.limit) params["limit"] = String(opts.limit);
  const res = await http.get<{ events: EventSummary[] }>("/events/recent", { params });
  return res.data.events;
}

export async function retryEvent(key: string): Promise<void> {
  await http.post(`/events/${encodeURIComponent(key)}/retry`);
}
